import styled from "styled-components";
import LogoImg from "../../imagens/logo.png";

const LogoVal = styled.img`
    width: 80px;
    height: 80px;
    margin: 0 auto;
`

function Logo({className}) {
    return(
        <LogoVal src={LogoImg} className={className} title={className}/>
    )
}

export default Logo;